module.exports = __webpack_public_path__ + "static/media/OmicsBioAnalytics_logo_screen.99fca59d.png";